import { institutionConstants as inst } from "../../../constants/intitutions";

const initialState = { loading: true, list: [], data: null };

export default function(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case inst.GET_INSTITUTIONS:
      return {
        ...state,
        loading: false,
        list: payload,
      };
    case inst.GET_INSTITUTION:
      return {
        ...state,
        loading: false,
        data: payload,
      };
    default:
      return state;
  }
}
